import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10f3e53c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护充值活动信息")], -1));
const _hoisted_3 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "活动明细", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}充值活动`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "180px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "活动名称",
        prop: "promotionName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.promotionName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.promotionName = $event),
          placeholder: "请输入活动名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "活动描述",
        prop: "promotionDesc"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.promotionDesc,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.promotionDesc = $event),
          autosize: {
            minRows: 5,
            maxRows: 10
          },
          type: "textarea",
          placeholder: "请输入活动描述"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "开始时间",
        prop: "beginTime"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: $data.formModel.beginTime,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.beginTime = $event),
          type: "datetime",
          placeholder: "请选择开始时间",
          format: "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "disabled-date": $options.disabledDate
        }, null, 8, ["modelValue", "disabled-date"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "结束时间",
        prop: "endTime"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: $data.formModel.endTime,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.endTime = $event),
          type: "datetime",
          placeholder: "请选择结束时间",
          format: "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "disabled-date": $options.disabledDate,
          onChange: $options.changeTime
        }, null, 8, ["modelValue", "disabled-date", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "图片"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          "file-list": $data.formModel.imgs,
          "onUpdate:fileList": _cache[4] || (_cache[4] = $event => $data.formModel.imgs = $event),
          class: _normalizeClass($data.formModel.imgs.length > 0 ? 'disabledImg' : ''),
          action: "",
          limit: "1",
          "list-type": "picture-card",
          "on-change": $options.changeFile,
          "on-preview": $options.handlePictureCardPreview,
          "before-remove": $options.beforeRemove,
          "auto-upload": false
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "iconfont icon-file-add"
          })]),
          _: 1
        }, 8, ["file-list", "class", "on-change", "on-preview", "before-remove"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_divider), _createVNode(_component_el_table, {
        data: $data.formModel.items,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "充值金额"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input_number, {
            style: {
              "width": "100%"
            },
            modelValue: scope.row.fee,
            "onUpdate:modelValue": $event => scope.row.fee = $event,
            min: 0,
            precision: 2,
            "controls-position": "right"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "赠送金额"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input_number, {
            style: {
              "width": "100%"
            },
            modelValue: scope.row.giveFee,
            "onUpdate:modelValue": $event => scope.row.giveFee = $event,
            min: 0,
            precision: 2,
            "controls-position": "right"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            onClick: $event => $options.deleteItem(scope.row),
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: $options.addItem
        }, {
          default: _withCtx(() => [_createTextVNode("增加活动明细")]),
          _: 1
        }, 8, ["onClick"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['rechargePromotion_add', 'rechargePromotion_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}